import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "components/Button";
import { InfoMessage } from "components/InfoMessage/InfoMessage";
import { ParagraphLarge } from "styles/elements/Texts";

export const BlockedPathMessage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <InfoMessage
      dataCy="blocked-path-message"
      icon="fas fa-ban"
      title={t("blockedPath.title", "Blocked path")}
    >
      <ParagraphLarge marginBottom={5}>
        {t("blockedPath.message", "The page you're trying to access is blocked at the moment.")}
      </ParagraphLarge>
      <Button dataCy="return-to-prev-page-button" onClick={() => navigate(-1)} variant="secondary">
        {t("blockedPath.button.goBack", "Go back to previous page")}
      </Button>
    </InfoMessage>
  );
};
